export function Logo({ size = "md", showText = true }) {
  const dims = { sm: 34, md: 46, lg: 96 }[size] || 46;
  const text = { sm: "text-lg", md: "text-2xl", lg: "text-4xl" }[size] || "text-2xl";
  return (
    <div className="flex items-center gap-3" data-testid="almar-logo">
      <img
        src="/almar-logo.jpeg"
        alt="Grupo Almar Investimentos"
        style={{ width: dims, height: dims }}
        className="rounded-lg object-cover ring-1 ring-[#C9A84C]/40"
      />
      {showText && (
        <div className="leading-tight">
          <div className={`font-display ${text} tracking-[0.25em] gold-text font-semibold`}>ALMAR</div>
          <div className="text-[9px] tracking-[0.35em] text-slate-400 uppercase">Grupo Almar</div>
        </div>
      )}
    </div>
  );
}
